import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
import { hasPrivilege } from '../api/token';
import TranslateLibraryView from '../components/TranslateLibrary';
import { useGetCloudKeyQuery } from '../services/lookupApi';
import { USER_UUID } from '../utils/constants';

export default function TranslateLibrary() {
  const navigate = useNavigate();
  const translator_view = hasPrivilege('translator_view');
  
  const userUuid = localStorage.getItem(USER_UUID);
  const { isLoading } = useGetCloudKeyQuery(userUuid, { skip: !userUuid });

  useEffect(() => {
    if (!translator_view) {
      navigate("/");
    }
  }, [navigate, translator_view])

  if (translator_view) {
    if (isLoading) return <Spin />;

    return (
      <div>
        <TranslateLibraryView />
      </div>
    )
  }
}
